export default "__VITE_ASSET__khQxOB$l__"